import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { GlobalContext } from '../contexts/GlobalContext';
import SettingsApp from './SettingsApp';
// import SettingsServer from './SettingsServer';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={2}>{children}</Box>}
        </div>
    );
}

function SettingsMain(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const globals = useContext(GlobalContext)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Paper className={classes.root}>
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab label="Application Settings" />
            </Tabs>
            <TabPanel value={value} index={0}>
                <div className="settingsTabPanel">
                    <SettingsApp data={globals} />
                </div>
            </TabPanel>

        </Paper>
    )
}

export default SettingsMain
